<template>
  <section class="inner-content-section pt-3 pb-4">
    <div class="background-color-sec container">
      <div class="flex flex-wrap -mx-3 footer-row align-items-center">
        <div class="w-full md:w-1/2 max-w-full px-3 text-center md:text-start">
          <p class="text-sm text-[var(--tone-gray)]">© {{ new Date().getFullYear() }}. All Right Reserved</p>
        </div>
        <div class="w-full md:w-1/2 max-w-full px-3 text-center md:text-end">
          <p class="text-sm text-[var(--tone-gray)]">Powered by Native American Tours </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Footer"
};
</script>
